const UPDATE_KYC_MUTATION = `mutation UpdateKycMutation(
  $kycId: ID!,
  $rawKycFirstName: String,
  $rawKycLastName: String,
  $rawKycPhoneNumber: String,
  $rawKycEmail: String,
  $rawKycSsn: String,
  $rawKycDob: VaultDobInput,
  $rawKycAddress: VaultAddressUpdateInput,
  $percentOwnership: Int,
  $title: String,
  $owner: Boolean
  ) {
  vaultKycUpdate(
    id: $kycId,
    firstName: $rawKycFirstName,
    lastName: $rawKycLastName,
    phoneNumber: $rawKycPhoneNumber,
    email: $rawKycEmail,
    ssn: $rawKycSsn,
    dob: $rawKycDob,
    address: $rawKycAddress,
    percentOwnership: $percentOwnership,
    title: $title,
    owner: $owner)
}`;

export const requestBodyFormatter =
  ({
    kycId,
    kycAddressRegion,
    kycPercentOwnership,
    kycTitle,
    kycOwner,
  }: {
    kycId: string;
    kycAddressRegion: string;
    kycPercentOwnership: number;
    kycTitle: string;
    kycOwner?: boolean;
  }) =>
  (formValues: Record<string, string>): VgsRequestBody => ({
    query: UPDATE_KYC_MUTATION,
    variables: {
      kycId,
      rawKycFirstName: formValues.kycFirstName,
      rawKycLastName: formValues.kycLastName,
      rawKycPhoneNumber: formValues.kycPhoneNumber,
      rawKycEmail: formValues.kycEmail,
      rawKycDob: {
        month: formValues.kycDobMonth,
        day: formValues.kycDobDay,
        year: formValues.kycDobYear,
      },
      rawKycAddress: {
        street: formValues.kycAddressStreet,
        unit: formValues.kycAddressUnit,
        city: formValues.kycAddressCity,
        region: kycAddressRegion,
        postalCode: formValues.kycPostalCode,
      },
      rawKycSsn: formValues.kycSsn,
      percentOwnership: kycPercentOwnership,
      owner: kycOwner,
      title: kycTitle,
    },
  });
